<template>
    <div style="padding: 20px">
        <el-drawer :visible.sync="isShow" title="授权角色" size="800px" hide-footer @close="$emit('close')">
        <el-form :inline="true" :model="searchForm" ref="searchForm" @keydown.enter.native="handleSearch">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="searchForm.name" placeholder="请输入角色名称" size="small" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="roleDesc">
                    <el-input v-model="searchForm.roleDesc" placeholder="请输入角色描述" size="small" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="角色类型" prop="roleType">
                    <el-select v-model="searchForm.roleType" placeholder="请选择角色类型">
                        <el-option label="内置角色" :value="0"></el-option>
                        <el-option label="自定义角色" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">搜索</el-button>
                    <el-button @click="handleReset('searchForm')" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" size="small" @click="handleAddHotel">绑定授权</el-button>
            </div>

            <el-table border style="width:100%;margin-top:10px;" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="hotelList" size="small">
                <el-table-column type="index" label="#" fixed="left" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="角色名称" align="center"></el-table-column>
                <el-table-column prop="roleDesc" label="角色描述" align="center"></el-table-column>
                <el-table-column prop="roleType" label="角色类型" align="center">
                    <template slot-scope="{ row }">
                        <el-tag v-if="row.roleType === 0">内置角色</el-tag>
                        <el-tag type="success" v-else>自定义角色</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width='100'>
                    <template slot-scope="{row}">
                        <el-button type="danger" size="mini" @click="handleUnBindHotel(row)">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: right; padding: 10px 20px 0 0;">
                <el-pagination @size-change="handleChangesize" @current-change="handleChangePage" :current-page="searchForm.pageNumber" :page-sizes="[10, 20,50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-drawer>

        <!-- 选择酒店的弹窗 -->
        <el-dialog width="680px" title="请选择角色" :visible.sync="isSelect" @click="isSelect=false" append-to-body destroy-on-close :close-on-press-escape="false" :cel-dialoglose-on-click-modal="false">
            <el-form :inline="true" :model="selectForm" ref="selectForm" @keydown.enter.native="handleSearchHotel">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="selectForm.name" placeholder="请输入角色名称" size="small" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="roleDesc">
                    <el-input v-model="selectForm.roleDesc" placeholder="请输入角色描述" size="small" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="角色类型" prop="roleType">
                    <el-select v-model="selectForm.roleType" placeholder="请选择角色类型">
                        <el-option label="内置角色" :value="0"></el-option>
                        <el-option label="自定义角色" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearchHotel" size="small">搜索</el-button>
                    <el-button @click="resetForm('selectForm')" size="small">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="selectHotelList" style="width: 100%" border size="mini" row-key="hotelId" @select="handleselectionsChange"
                @select-all="handleSelectAll">
                <el-table-column type="selection" label="#" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="角色名称"></el-table-column>
                <el-table-column prop="roleDesc" label="角色描述" align="center"></el-table-column>
                <el-table-column prop="roleType" label="角色类型" align="center">
                    <template slot-scope="{ row }">
                        <el-tag v-if="row.roleType === 0">内置角色</el-tag>
                        <el-tag type="success" v-else>自定义角色</el-tag>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align:right;margin-top:10px;">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="hotelTotal" @current-change="handleChangeSelectPage" :current-page="selectForm.pageNumber" :page-size="selectForm.pageSize"></el-pagination>
            </div>

            <div slot="footer" class="dialog-footer" style="text-align: right;padding-top: 20px">
                <el-button size="small" @click="handleCancel">取 消</el-button>
                <el-button size="small" :loading="submitLoading" type="primary" @click="handleSubmit">确认</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { removeArrRepeat } from "@/utils/util";
export default {
    props: {
        httpConfig: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showCode: {
            type: Boolean,
            default: false
        },
        propsData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        tableProp: {
            type: Object,
            default: () => {
                return {
                    nickname: 'nickname'
                }
            }
        },
        isBind: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isShow: false,
            loading: false,
            searchForm: {
                pageNumber: 1,
                name: '',
                roleId: '',
                pageSize: 10
            },
            selectForm: {
                name: '',
                pageNumber: 1,
                pageSize: 10
            },
            total: 0,
            hotelList: [],
            hotelTotal: 0,
            isSelect: false,
            submitLoading: false,
            selectHotelList: [],
            selections: [],
        }
    },
    watch: {
        isBind(newVal) {
            this.isShow = !!newVal;
            if (newVal) {
                const { roleId } = this.propsData
                this.searchForm = Object.assign(this.searchForm, {roleId} )
                this.getHotelList();
            }
        }
    },
    methods: {
        handleSubmit() {
            if (!this.selections.length) {
                this.$message.warning("请选择需要绑定的角色");
                return;
            }
            this.submitLoading = true;
            this.handleSubmitBindHotel();
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getHotelList();
        },
        handleReset() {
            this.searchForm = {
                pageNumber: 1,
                name: '',
                roleId: this.searchForm.roleId,
                pageSize: 10
            }
            this.getHotelList();
        },
        handleSubmitBindHotel() {
            let postData = Object.assign({}, this.propsData);
            postData.toRoleIdList = this.selections.map(item => {
                return item.id;
            })

            this.postRequest(this.httpConfig.bindHotel, postData)
                .then(res => {
                    let data = res.data;

                    this.submitLoading = false;
                    if (data.code == 200) {

                        this.$message.success(data.msg);
                        this.isSelect = false;
                        this.searchForm.pageNumber = 1;
                        this.getHotelList();
                    } else {
                        this.$message.warning(data.msg);
                        this.isSelect = false;
                    }
                }).catch(err => {
                    this.submitLoading = false;
                })
        },
        handleCancel() {//选择的绑定酒店
            this.isSelect = false;
            this.searchForm = {
                pageNumber: 1,
                name: '',
                roleId: '',
                pageSize: 10
            }
            this.getHotelList();
        },
        handleAddHotel() {
            this.isSelect = true;
            this.selections = [];
            this.getAllHotelList();
        },
        handleUnBindHotel(row) {
            this.$confirm('是否解绑该角色?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleUnBindHotelApi({id: row.id});
            }).catch(() => {

            });
        },
        handleselectionsChange(val, row) {
            let isTrue = false;
            this.selections.forEach((item, index) => {
                if (item.id == row.id) {
                    this.selections.splice(index, 1);
                    isTrue = true;
                }
            });
            if (!isTrue) {
                this.selections.push(row);
            }
        },
        handleSelectAll(val) {
            var _this = this;

            if (!_this.selections.length) {
                [..._this.selections] = val;
            } else {
                if (val.length) {
                    _this.selections = removeArrRepeat(_this.selections.concat(val));
                } else {
                    _this.selectHotelList.forEach((item, index) => {
                        _this.selections.forEach((val, key) => {
                            if (val.id == item.id) {
                                _this.selections.splice(key, 1);
                            }
                        });
                    });
                }
            };
        },
        handleUnBindHotelApi(data) {
            this.formDataPost(this.httpConfig.unbindHotel, data)
                .then(res => {
                    let data = res.data;

                    if (data.code == 200) {
                        this.$message.success(data.msg);
                        this.searchForm.pageNumber = 1;
                        this.getHotelList();
                    }
                })
        },
        handleSearchHotel() {
            this.selectForm.pageNumber = 1;
            this.getAllHotelList();
        },
        resetForm() {
            this.selectForm.name = "";
            this.selectForm.roleType = "";
            this.selectForm.roleDesc = '';
            this.selectForm.pageNumber = 1;
            this.getAllHotelList();
        },

        handleChangeSelectPage(page) {
            this.selectForm.pageNumber = page;
            this.getAllHotelList();
        },
        handleChangePage(v) {
            this.searchForm.pageNumber = v;
            this.getHotelList();

        },
        handleChangesize(v) {
            this.searchForm.pageSize = v;
            this.searchForm.pageNumber = 1;
            this.getHotelList();
        },
        getHotelList() {
            this.getRequest(this.httpConfig.getHotel, this.searchForm).then(res => {
                let data = res.data;

                if (data.code == 200) {
                    this.hotelList = data.data.records;
                    this.total = data.data.total;
                }
            })
        },
        getAllHotelList() {
            this.getRequest(this.httpConfig.selectHotel, this.selectForm).then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.selectHotelList = data.data.records;
                    this.hotelTotal = data.data.total;

                    this.$nextTick(() => {
                        if (this.selectHotelList.length) {
                            this.$refs.multipleTable.clearSelection();
                            this.selections.forEach(row => {
                                this.selectHotelList.forEach(item => {

                                    if (row.id == item.roleId) {
                                        this.$refs.multipleTable.toggleRowSelection(item, true);
                                    }
                                })

                            });
                        } else {
                            this.$refs.multipleTable.clearSelection();
                        };
                    })
                }
            })
        },
    },
}
</script>